export default __webpack_public_path__ + "static/media/team.cac63634.svg";